import { Injectable, inject } from '@angular/core';
import { App } from '@df/core/app';
import { GoogleMapsService } from '@df/module-google-maps/google-maps.service';
import { GtmService } from '@df/module-gtm/gtm.service';
import { toGraylog } from '../to-graylog';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsServiceDecorator extends GoogleMapsService {
    private gtmService = inject(GtmService);
    private appCopy = inject(App);

    override load(): Promise<void> {
        if (this.appCopy.client.isBot) {
            return new Promise(r => {});
        }
        this.gtmService.trackNonInteractionEvent('gmaps', 'load', this.appCopy.isPlatformBrowser ? location.pathname : 'universal');
        toGraylog('gmaps service load', { userAgent: this.appCopy.isPlatformBrowser ? navigator.userAgent : 'universal' });
        return super.load();
    }
}
